export enum EstadoDocumentoLicencia {
  ingresada = 1,
  valida = 2,
  no_valida = 3
}